import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Course, StepBlock, StepsCategoryModel } from '@tekman/onmat/models';
import { of } from 'rxjs/internal/observable/of';
import { catchError, map, switchMap } from 'rxjs/operators';
import { CoursesService } from '../service/courses.service';
import * as coursesActions from './courses.actions';

@Injectable()
export class CoursesEffects {
  constructor(private readonly _actions$: Actions, private readonly coursesService: CoursesService) {}

  courses$ = createEffect(() =>
    this._actions$.pipe(
      ofType(coursesActions.loadCourses),
      switchMap(_ =>
        this.coursesService.getCourses().pipe(
          map((courses: Course[]) => coursesActions.loadCoursesSuccess({ courses })),
          catchError((error: HttpErrorResponse) =>
            of(coursesActions.loadCoursesFailure({ error: { message: error?.message, type: 'courses' } }))
          )
        )
      )
    )
  );

  blocks$ = createEffect(() =>
    this._actions$.pipe(
      ofType(coursesActions.loadStepBlocksByCourse),
      switchMap(action =>
        this.coursesService.getCourseSteps(action.courseId, action.groupId).pipe(
          map((blocks: StepBlock[]) => coursesActions.loadStepBlocksByCourseSuccess({ courseId: action.courseId, blocks })),
          catchError((error: HttpErrorResponse) =>
            of(coursesActions.loadCoursesFailure({ error: { message: error?.message, type: 'blocks' } }))
          )
        )
      )
    )
  );

  steps$ = createEffect(() =>
    this._actions$.pipe(
      ofType(coursesActions.loadSteps),
      switchMap(action =>
        this.coursesService.getStepsByGroup(action.stepId, action.groupId).pipe(
          map((stepsCategory: StepsCategoryModel) => coursesActions.loadStepsSuccess({ stepsCategory })),
          catchError((error: HttpErrorResponse) =>
            of(coursesActions.loadCoursesFailure({ error: { message: error?.message, type: 'steps' } }))
          )
        )
      )
    )
  );
}
